import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { MdDownloadForOffline } from "react-icons/md";
import PublicWebsiteActions from "../../Actions/PublicWebsiteActions";
import PublicWebsiteConstants from "../../Constants/PublicWebsiteConstants";
import publicWebsiteStore from "../../Stores/PublicWebsiteStore";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../Context/LanguageContext";

export default function DocumentData({ documents }) {
  const [documentList, setDocumentList] = useState([]);
  const UpdateLanguage = useLanguageActionContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { language, localization } = useLanguageContext();
  useEffect(() => {
    if (documents && documents.length > 0) {
      setDocumentList(documents);
    }
    return () => {};
  }, [documents]);

  useEffect(() => {
    UpdateLanguage(language);
    return () => {};
  }, [language]);

  function downloadFile(id, name) {
    setGlobalSpinner(true);
    PublicWebsiteActions.downloadDocument(id, name);
  }

  useEffect(() => {
    function downloadDocSuccess() {
      var res = publicWebsiteStore.getDownloadDocResult();
      if (res) {
        toast.success(res);
      }
      setGlobalSpinner(false);
    }

    function downloadDocFailure() {
      var res = publicWebsiteStore.getDownloadDocResult();
      setGlobalSpinner(false);
      toast.error(localization.fileDownloadError);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.DOWNLOAD_DOC_SUCCESS,
      downloadDocSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.DOWNLOAD_DOC_FAILURE,
      downloadDocFailure
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.DOWNLOAD_DOC_SUCCESS,
        downloadDocSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.DOWNLOAD_DOC_FAILURE,
        downloadDocFailure
      );
    };
  }, [language]);

  return (
    <div className="container masterData">
      {documentList.length == 0 ? (
        <div>{localization.noDocuments}</div>
      ) : (
        documentList.map((document, index) => {
          return (
            <div key={index} className="row p-3 mb-2">
              <div className="col-10 docNameCls">{document.bezeichnung}</div>
              <div className="col-2 text-right">
                <MdDownloadForOffline
                  style={{ fontSize: "24px", cursor: "pointer" }}
                  onClick={() => {
                    downloadFile(document.id, document.bezeichnung);
                  }}
                />
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
